<div *ngIf="outageBanners.length > 0">
  <div class="outage-banner mt-1 mb-1" *ngFor="let outageBanner of outageBanners">
    <div class="container pt-1">
      <div style="display: flex; justify-content: start">
        <i [ngClass]="outageBanner.iconClass || ''">&nbsp;</i>
        <h2>{{ outageBanner.title }}</h2>
      </div>
      <p style="margin: 0" class="unwantedP" [innerHTML]="outageBanner.body || '' | mdToHtml"></p>
    </div>
  </div>
</div>
